<template>
    <div class="row justify-content-center mt-5 pt-4">
        <div class="col-10 mt-2">
            <nav class="flex-column">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab"
                        @click="getType(1)" aria-controls="nav-home" aria-selected="true">T&C</a>
                    <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab"
                        @click="getType(2)" aria-controls="nav-profile" aria-selected="false">T&C Facebook</a>
                    <a class="nav-item nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab"
                        @click="getType(3)" aria-controls="nav-contact" aria-selected="false">Políticas de
                        privacidad</a>
                    <a class="nav-item nav-link" id="nav-cc-tab" data-toggle="tab" href="#nav-cc" role="tab"
                        @click="getType(4)" aria-controls="nav-contact" aria-selected="false">Comunicado de
                        coljuegos</a>
                    <a class="nav-item nav-link" id="nav-cch-tab" data-toggle="tab" href="#nav-cch" role="tab"
                        @click="getType(5)" aria-controls="nav-contact" aria-selected="false">Comunicado clientes
                        havoline</a>
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group" style="color: black; text-align: left;">
                                <div class="row mt-3">
                                    <div class="col-10">
                                        <label for="exampleFormControlFile5"><strong>Términos y condiciones</strong></label>
                                        <form ref="form1">
                                            <input
                                                accept=".doc,.docx, .pdf, .odt, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                type="file" @change="getFile($event)" class="form-control-file"
                                                id="exampleFormControlFile5" />
                                        </form>
                                        <small class="text-info">Las extensiones válidas son: .doc,.docx, .pdf,
                                            .odt</small>
                                    </div>
                                    <div class="col-2">
                                        <button @click="publicate()" :disabled="loading.publicate"
                                            :hidden="hidden.publicate" class="btn btn-danger btn-block mt-3">
                                            <template v-if="!loading.publicate">
                                                Publicar
                                            </template>
                                            <template v-else>
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true"></span>
                                                Cargando...
                                            </template>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row" v-if="listHistoryFile.length > 0">
                                <div class="col-12">
                                    <template v-if="loading.history">
                                        <div class="d-flex justify-content-center">
                                            <div class="spinner-border text-danger" style="width: 4em; height: 4rem;"
                                                role="status">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="table-responsive">
                                            <table class="table table-hover table-sm">
                                                <caption class="visually-hidden">Listado de Documentos</caption>
                                                <thead>
                                                    <tr>
                                                        <th scope="col" class="table-doc-td">Nombre archivo</th>
                                                        <th scope="col">Fecha de modificación</th>
                                                        <th scope="col">Estado</th>
                                                        <th scope="col">Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="data in listHistoryFile" :key="data.id">
                                                        <td class="table-doc-td"><a :href="data.url"
                                                                target="_blank">{{data.name}}</a></td>
                                                        <td> <label class="text-dark">{{data.updated_at}}</label>
                                                        </td>
                                                        <td>
                                                            <label v-if="data.status_id == 1" style="color: #dc3545">
                                                                {{data.status.name}}
                                                            </label>
                                                            <label v-else style="color: gray"> {{data.status.name}}
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <input v-model="selectedDoc" @change="confirmation($event)"
                                                                :value="data.id" type="radio" :id="data.id">
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </template>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group" style="color: black; text-align: left;">
                                <div class="row mt-3">
                                    <div class="col-12 col-md-7 col-lg-10 col-xl-10 col-sm-12">
                                        <label for="exampleFormControlFile1"><strong>Términos y condiciones
                                                facebook</strong></label>
                                        <form ref="form2">
                                            <input
                                                accept=".doc,.docx, .pdf, .odt, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                type="file" @change="getFile($event)" class="form-control-file"
                                                id="exampleFormControlFile1" />
                                        </form>
                                        <small class="text-info">Las extensiones válidas son: .doc,.docx, .pdf,
                                            .odt</small>
                                    </div>
                                    <div class="col-8 col-md-3 col-lg-2 col-xl-2 col-sm-2">
                                        <button @click="publicate()" :disabled="loading.publicate"
                                            :hidden="hidden.publicate" class="btn btn-danger btn-block mt-3">
                                            <template v-if="!loading.publicate">
                                                Publicar
                                            </template>
                                            <template v-else>
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true"></span>
                                                Cargando...
                                            </template>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row" v-if="listHistoryFile.length > 0">
                                <div class="col-12">
                                    <template v-if="loading.history">
                                        <div class="d-flex justify-content-center">
                                            <div class="spinner-border text-danger" style="width: 4em; height: 4rem;"
                                                role="status">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="table-responsive">
                                            <table class="table table-hover table-sm">
                                                <caption class="visually-hidden">Listado de Documentos</caption>
                                                <thead>
                                                    <tr>
                                                        <th scope="col" class="table-doc-td">Nombre archivo</th>
                                                        <th scope="col">Fecha de modificación</th>
                                                        <th scope="col">Estado</th>
                                                        <th scope="col">Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="data in listHistoryFile" :key="data.id">
                                                        <td class="table-doc-td"><a :href="data.url"
                                                                target="_blank">{{data.name}}</a></td>
                                                        <td> <label class="text-dark">{{data.updated_at}}</label>
                                                        </td>
                                                        <td>
                                                           <label v-if="data.status_id == 1" style="color: #dc3545">
                                                                {{data.status.name}}
                                                            </label>
                                                            <label v-else style="color: gray"> {{data.status.name}}
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <input v-model="selectedDoc" @change="confirmation($event)"
                                                                :value="data.id" type="radio" :id="data.id">
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group" style="color: black; text-align: left;">
                                <div class="row mt-3">
                                    <div class="col-10">
                                        <label for="exampleFormControlFile2"><strong>Políticas de privacidad</strong></label>
                                        <form ref="form3">
                                            <input
                                                accept=".doc,.docx, .pdf, .odt, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                type="file" @change="getFile($event)" class="form-control-file"
                                                id="exampleFormControlFile2" />
                                        </form>
                                        <small class="text-info">Las extensiones válidas son: .doc,.docx, .pdf,
                                            .odt</small>
                                    </div>
                                    <div class="col-2">
                                        <button @click="publicate()" :disabled="loading.publicate"
                                            :hidden="hidden.publicate" class="btn btn-danger btn-block mt-3">
                                            <template v-if="!loading.publicate">
                                                Publicar
                                            </template>
                                            <template v-else>
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true"></span>
                                                Cargando...
                                            </template>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row" v-if="listHistoryFile.length > 0">
                                <div class="col-12">
                                    <template v-if="loading.history">
                                        <div class="d-flex justify-content-center">
                                            <div class="spinner-border text-danger" style="width: 4em; height: 4rem;"
                                                role="status">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="table-responsive">
                                            <table class="table table-hover table-sm">
                                                <caption class="visually-hidden">Listado de Documentos</caption>
                                                <thead>
                                                    <tr>
                                                        <th scope="col" class="table-doc-td">Nombre archivo</th>
                                                        <th scope="col">Fecha de modificación</th>
                                                        <th scope="col">Estado</th>
                                                        <th scope="col">Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="data in listHistoryFile" :key="data.id">
                                                        <td class="table-doc-td"><a :href="data.url"
                                                                target="_blank">{{data.name}}</a></td>
                                                        <td> <label class="text-dark">{{data.updated_at}}</label>
                                                        </td>
                                                        <td>
                                                            <label v-if="data.status_id == 1" style="color: #dc3545">
                                                                {{data.status.name}}
                                                            </label>
                                                            <label v-else style="color: gray"> {{data.status.name}}
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <input v-model="selectedDoc" @change="confirmation($event)"
                                                                :value="data.id" type="radio" :id="data.id">
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-cc" role="tabpanel" aria-labelledby="nav-cc-tab">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group" style="color: black; text-align: left;">
                                <div class="row mt-3">
                                    <div class="col-10">
                                        <label for="exampleFormControlFile3"><strong>Comunicado de coljuegos</strong></label>
                                        <form ref="form4">
                                            <input
                                                accept=".doc,.docx, .pdf, .odt, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                type="file" @change="getFile($event)" class="form-control-file"
                                                id="exampleFormControlFile3" />
                                        </form>
                                        <small class="text-info">Las extensiones válidas son: .doc,.docx, .pdf,
                                            .odt</small>
                                    </div>
                                    <div class="col-2">
                                        <button @click="publicate()" :disabled="loading.publicate"
                                            :hidden="hidden.publicate" class="btn btn-danger btn-block mt-3">
                                            <template v-if="!loading.publicate">
                                                Publicar
                                            </template>
                                            <template v-else>
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true"></span>
                                                Cargando...
                                            </template>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row" v-if="listHistoryFile.length > 0">
                                <div class="col-12">
                                    <template v-if="loading.history">
                                        <div class="d-flex justify-content-center">
                                            <div class="spinner-border text-danger" style="width: 4em; height: 4rem;"
                                                role="status">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="table-responsive">
                                            <table class="table table-hover table-sm">
                                                <caption class="visually-hidden">Listado de Documentos</caption>
                                                <thead>
                                                    <tr>
                                                        <th scope="col" class="table-doc-td">Nombre archivo</th>
                                                        <th scope="col">Fecha de modificación</th>
                                                        <th scope="col">Estado</th>
                                                        <th scope="col">Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="data in listHistoryFile" :key="data.id">
                                                        <td class="table-doc-td"><a :href="data.url"
                                                                target="_blank">{{data.name}}</a></td>
                                                        <td> <label class="text-dark">{{data.updated_at}}</label>
                                                        </td>
                                                        <td>
                                                          <label v-if="data.status_id == 1" style="color: #dc3545">
                                                                {{data.status.name}}
                                                            </label>
                                                            <label v-else style="color: gray"> {{data.status.name}}
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <input v-model="selectedDoc" @change="confirmation($event)"
                                                                :value="data.id" type="radio" :id="data.id">
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="nav-cch" role="tabpanel" aria-labelledby="nav-cch-tab">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group" style="color: black; text-align: left;">
                                <div class="row mt-3">
                                    <div class="col-10">
                                        <label for="exampleFormControlFile4"><strong>Comunicado clientes havoline</strong></label>
                                        <form ref="form5">
                                            <input
                                                accept=".doc,.docx, .pdf, .odt, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                type="file" @change="getFile($event)" class="form-control-file"
                                                id="exampleFormControlFile4" />
                                        </form>
                                        <small class="text-info">Las extensiones válidas son: .doc,.docx, .pdf,
                                            .odt</small>
                                    </div>
                                    <div class="col-2">
                                        <button @click="publicate()" :disabled="loading.publicate"
                                            :hidden="hidden.publicate" class="btn btn-danger btn-block mt-3">
                                            <template v-if="!loading.publicate">
                                                Publicar
                                            </template>
                                            <template v-else>
                                                <span class="spinner-border spinner-border-sm" role="status"
                                                    aria-hidden="true"></span>
                                                Cargando...
                                            </template>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row" v-if="listHistoryFile.length > 0">
                                <div class="col-12">
                                    <template v-if="loading.history">
                                        <div class="d-flex justify-content-center">
                                            <div class="spinner-border text-danger" style="width: 4em; height: 4rem;"
                                                role="status">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="table-responsive">
                                            <table class="table table-hover table-sm">
                                                <caption class="visually-hidden">Listado de Documentos</caption>
                                                <thead>
                                                    <tr>
                                                        <th scope="col" class="table-doc-td">Nombre archivo</th>
                                                        <th scope="col">Fecha de modificación</th>
                                                        <th scope="col">Estado</th>
                                                        <th scope="col">Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="data in listHistoryFile" :key="data.id">
                                                        <td class="table-doc-td"><a :href="data.url"
                                                                target="_blank">{{data.name}}</a></td>
                                                        <td> <label class="text-dark">{{data.updated_at}}</label>
                                                        </td>
                                                        <td>
                                                     <label v-if="data.status_id == 1" style="color: #dc3545">
                                                                {{data.status.name}}
                                                            </label>
                                                            <label v-else style="color: gray"> {{data.status.name}}
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <input v-model="selectedDoc" @change="confirmation($event)"
                                                                :value="data.id" type="radio" :id="data.id">
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal preguntar cambio  -->
        <div class="modal fade" id="questionsDoc" data-backdrop="static" data-keyboard="false" tabindex="-1"
            role="dialog" aria-labelledby="questionsDocLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered border-danger " role="document">
                <div class="modal-content modal-question">
                    <div class="modal-body">
                        <button type="button" @click="closeModal()" class="close">
                            <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
                        </button>
                        <div class="mt-3 row justify-content-center">
                            <div class="col-12">
                                <label style="color: #616161;">
                                    <strong> ¿Estas seguro que deseas cambiar el documento?</strong>
                                </label><br />
                                <label style="color: #616161;">
                                    Una vez aceptado se visualizará el documento seleccionado.</label>
                            </div>
                            <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                                <button @click="closeModal()" type="button"
                                    class="btn btn-secondary btn-sm btn-block button-login">
                                    <span v-if="loading.changeDoc" class="spinner-border spinner-border-sm"
                                        role="status" aria-hidden="true"></span>
                                    <template v-else>Cancelar</template>
                                </button>
                            </div>
                            <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                                <button @click="confirmationChange()" data-dismiss="modal" aria-label="Close"
                                    type="button" class="btn btn-danger btn-sm btn-block button-login">
                                    <span v-if="loading.changeDoc" class="spinner-border spinner-border-sm"
                                        role="status" aria-hidden="true"></span>
                                    <template v-else>Aceptar</template>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import axios from 'axios';

export default {
    name: "adminDocuments",
    data() {
        return {
            current: null,
            selectedDoc: null,
            active1: false,
            type: 1,
            loading: {
                publicate: false,
                history: false,
                changeDoc: false
            },
            hidden: {
                publicate: true
            },
            listHistoryFile: [],
            listFile: [],
            file: null,
            name: "",
            example: true
        };
    },
    methods: {
        closeModal() {
            this.selectedDoc = this.current;
            $("#questionsDoc").modal("hide");
        },
        confirmationChange() {
            var data = {
                type: this.type,
                file_id: this.selectedDoc
            }
            console.log(data)
            this.loading.changeDoc = true;
            axios.post("superAdmin/files/reActive", data).then(res => {
                if (res.data.cod == 0) {
                    this.$swal({
                        confirmButtonColor: "#dc3545",
                        icon: "success",
                        title: "Muy bien",
                        text: res.data.message
                    });
                    this.loading.changeDoc = false;
                    $("#questionsDoc").modal("hide");
                    this.getHistory();
                }
            }).catch(error => {
                this.loading.changeDoc = false;
                this.$swal({
                    confirmButtonColor: "#dc3545",
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message
                });
            });
        },
        confirmation(e) {
            if (this.current != parseInt(e.target.value)) {
                $("#questionsDoc").modal("show");
            }
        },
        remove() {
            switch (this.type) {
                case 1:
                    this.loading.history = false;
                    this.$refs.form1.reset();
                    break;
                case 2:
                    this.loading.history = false;
                    this.$refs.form2.reset();
                    break;
                case 3:
                    this.loading.history = false;
                    this.$refs.form3.reset();
                    break;
                case 4:
                    this.loading.history = false;
                    this.$refs.form4.reset();
                    break;
                case 5:
                    this.loading.history = false;
                    this.$refs.form5.reset();
                    break;
                default:
                    break;
            }
        },
        getHistory() {
            this.loading.history = true;
            axios.get("superAdmin/files/histories/" + this.type).then(res => {
                if (res.data.cod == 0) {
                    this.listFile = res.data.data;
                    this.listHistoryFile = [];
                    this.listFile.forEach(element => {
                        if(element.type_id < 6){
                            this.listHistoryFile.push(element);
                        }
                    });
                    for (let i = 0; i < this.listHistoryFile.length; i++) {
                        if (this.listHistoryFile[i].status_id == 1) {
                            this.listHistoryFile[i].active = true;
                            this.selectedDoc = this.listHistoryFile[i].id;
                            this.current = this.listHistoryFile[i].id;
                        } else {
                            this.listHistoryFile[i].active = false;
                        }
                    }
                }
                this.loading.history = false;
            }).catch(error => {
                this.loading.history = false;
                this.$swal({
                    confirmButtonColor: "#dc3545",
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message
                });
            });
        },
        publicate() {
            const formData = new FormData()
            formData.append('file[0][file]', this.file);
            formData.append('name', this.name);
            formData.append('order', null);
            formData.append('type', this.type);
            formData.append('description', null);
            this.loading.publicate = true;
            axios.post("superAdmin/files/create", formData).then(res => {
                if (res.data.cod == 0) {
                    this.$swal({
                        confirmButtonColor: "#dc3545",
                        icon: "success",
                        title: "Muy bien",
                        text: res.data.message
                    });
                    this.remove();
                    this.loading.publicate = false;
                    this.hidden.publicate = true;
                    this.getHistory();
                }
            }).catch(error => {
                this.loading.publicate = false;
                this.$swal({
                    confirmButtonColor: "#dc3545",
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message
                });
            });
        },
        getFile(data) {
            this.file = data.target.files[0];
            this.name = this.file.name;
            var extension = this.name.split(".");
            console.log(extension)
            if (this.file.size > 1000000) {
                this.$swal({
                    confirmButtonColor: "#dc3545",
                    icon: "error",
                    title: "Oops...",
                    text: "El tamaño del archivo debe ser menor a 1 MB"
                });
                this.remove();
            } else if (extension[1] != "doc" && extension[1] != "odt" && extension[1] != "docx" && extension[1] != "pdf") {
                this.$swal({
                    confirmButtonColor: "#dc3545",
                    icon: "error",
                    title: "Oops...",
                    text: "La extensión del archivo es inválida"
                });
                this.remove();
            } else {
                this.hidden.publicate = false;
            }

        },
        getType(type) {
            this.file = null;
            this.type = type;
            this.hidden.publicate = true;
            this.remove();
            this.getHistory();
        }
    },
    created() {

    },
    mounted() {
        this.getHistory()
    }
}
</script>

<style>
.text-dark {
    color: black !important;
}
.table-doc-td {
    text-align: initial;
}
.visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
</style>